module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Page batches","button":"Add new batch","all":"All"}}')
  delete Component.options._Ctor
}
